import axios from 'axios';
const api = axios.create({
     baseURL: 'https://s2qrcode.com.br/api/modulo1',

})



export default api;